import { useContext } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import GlobalStateContext from '../../context/GlobalStateContext';
import Loader from '../reusable/Loader';
import { NAVIGATION_LINKS_DATA } from '../../constants';
import { getRoleHomePath, hasSelectedEoa } from './districtSelectionUtils';

const DistrictSelectionGate = () => {
  const location = useLocation();
  const {
    userDetails: { isPending: isUserDetailsPending, data: userDetails },
    allEoas: { isPending: isAllEoasPending },
    requiresDistrictSelection,
  } = useContext(GlobalStateContext);

  if (isUserDetailsPending || isAllEoasPending) {
    return <Loader fullScreen={true} />;
  }

  const isOnSelectDistrictPage = location.pathname === NAVIGATION_LINKS_DATA.SELECT_DISTRICT.path;

  if (requiresDistrictSelection && !isOnSelectDistrictPage) {
    return <Navigate to={NAVIGATION_LINKS_DATA.SELECT_DISTRICT.path} replace />;
  }

  if (!requiresDistrictSelection && isOnSelectDistrictPage && hasSelectedEoa(userDetails)) {
    return <Navigate to={getRoleHomePath(userDetails!.role)} replace />;
  }

  return <Outlet />;
};

export default DistrictSelectionGate;
